import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-immersion',
  templateUrl: './immersion.component.html',
  styleUrls: ['./immersion.component.css']
})
export class ImmersionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
